import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import {pontosModuleName, pontosStorage} from "../shared/data.service";
import {Ponto} from "../shared/ponto.model";
import {editRoute, newRoute, configuracaoModuleName} from "../../../shared/services/data.service";
import {PontoNavigationService} from "../shared/ponto-navigation.service";
import {PontoApiService} from "../shared/ponto-api.service";
import {PontoService} from "../shared/ponto.service";
import {UtilService} from "../../../shared/services/util.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {Endereco} from "../../../estruturas/enderecos/shared/endereco.model";
import {EnderecoService} from "../../../estruturas/enderecos/shared/endereco.service";
import {viagensModuleName} from "../../shared/data.service";
import {ViagemService} from "../../shared/viagem.service";

@Component({
    template: require('./ponto-form.component.html'),
    styles: [require('./ponto-form.component.css')]
})
export class PontoFormComponent implements OnInit {
    pontosModule: any = pontosModuleName;
    formObject: any = new Ponto();
    formObjectToSave: any = new Ponto();
    enderecoObject: any = new Endereco();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    showAddress: boolean = false;
    configuracaoModule: any = configuracaoModuleName;
    module: any = viagensModuleName;

    form: FormGroup;
    ativo = new FormControl('');
    nome = new FormControl('', Validators.required);
    descricao = new FormControl('');
    endereco = new FormControl('');

    private returnToOtherForm: boolean = false;
    private otherForm: string;
    private responsePonto: any;

    constructor(
        private _route: ActivatedRoute,
        private _pontoNavigationService: PontoNavigationService,
        private _pontoApiService: PontoApiService,
        private _pontoService: PontoService,
        private _enderecoService: EnderecoService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _viagemService: ViagemService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            nome: this.nome,
            descricao: this.descricao,
            endereco: this.endereco
        });
    }

    ngOnInit() {
        this.isNewAutoComplete();
    }

    clickGoToConfig() {
        this._viagemService.goToSetting();
    }

    clickGoToList() {
        this.goToList();
    }

    clickCancel() {
        this.toLeaveHere();
    }

    onSubmit(evt: any) {
        this.submitted = true;
        if(evt.valid) {
            this.btnSaveDisabled = true;

            this.formObjectToSave = this._utilService.cloneObject(this.formObject);
            this._enderecoService.onSubmit(this.enderecoObject, this.onDoneEndereco);
        }
    }

    private onDoneEndereco = (function (Response: any) {
        if (!Response.error)  {
            this.formObjectToSave.enderecoId = Response.id;
            if (this.formObject.id) {
                this.onEditPonto();
            } else {
                this.onAddPonto();
            }
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private onAddPonto() {
        this._pontoApiService.onPost(this.formObjectToSave, this.onDone);
    }

    private onEditPonto() {
        this._pontoApiService.onPut(this.formObjectToSave, this.onDone);
    }

    private onDone = (function (Response: any) {
        if (!Response.error)  {
            this.responsePonto = Response;

            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            this.toLeaveHere();

        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum ponto encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        this._pontoApiService.onGetById(id, onDone);
    }

    private testSession() {
        let id: number;
        const session: any = this._pontoService.getSessionStorage();
        this._pontoService.clearSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            this.setModelToForm();
        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {
        if (this.formObject.endereco) {
            this.enderecoObject = this.formObject.endereco;
            delete this.formObject['endereco'];
        }

        this.showAddress = true;
    }

    private toLeaveHere() {
        this.goToList();
    }

    private goToList() {
        this._pontoNavigationService.goToList();
    }

    private isNewAutoComplete() {
        const newAutoComplete: any = this._autocompleteService.getSessionStorage(pontosStorage);
        if (newAutoComplete) {
            this.returnToOtherForm = true;
            this.otherForm = newAutoComplete.form;
            this.formObject.nome = newAutoComplete.nome;

            this.setActionTitle(this.formObject.id);
            this.showAddress = true;
        } else {
            //retornando de um cadastro
            this.testSession();
        }
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        //se tiver alguma configuração inicial de um cadastro novo
        this.showAddress = true;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/ponto-form/ponto-form.component.ts
 **/